export const CREATE_SEMANTIC_MODEL_CLASS_PROFILE = "create-class-profile";
export function isCreateSemanticModelClassProfile(operation) {
    return operation.type === CREATE_SEMANTIC_MODEL_CLASS_PROFILE;
}
export const MODIFY_SEMANTIC_MODEL_CLASS_PROFILE = "modify-class-profile";
export function isModifySemanticModelClassProfile(operation) {
    return operation.type === MODIFY_SEMANTIC_MODEL_CLASS_PROFILE;
}
export const CREATE_SEMANTIC_MODEL_RELATIONSHIP_PROFILE = "create-relation-profile";
export function isCreateSemanticModelRelationshipProfile(operation) {
    return operation.type === CREATE_SEMANTIC_MODEL_RELATIONSHIP_PROFILE;
}
export const MODIFY_SEMANTIC_MODEL_RELATIONSHIP_PROFILE = "modify-relation-profile";
export function isModifySemanticModelRelationshipProfile(operation) {
    return operation.type === MODIFY_SEMANTIC_MODEL_RELATIONSHIP_PROFILE;
}
export const MODIFY_SEMANTIC_MODEL_RELATIONSHIP_END_PROFILE = "modify-relation-end-profile";
export function isModifySemanticModelRelationshipEndProfile(operation) {
    return operation.type === MODIFY_SEMANTIC_MODEL_RELATIONSHIP_END_PROFILE;
}
export const ADD_CONTROLLED_VOCABULARY_ASSIGNMENT = "add-controlled-vocabulary-assignment";
export function isAddControlledVocabularyAssignment(op) {
    return op.type === ADD_CONTROLLED_VOCABULARY_ASSIGNMENT;
}
export const REMOVE_CONTROLLED_VOCABULARY_ASSIGNMENT = "remove-controlled-vocabulary-assignment";
export function isRemoveControlledVocabularyAssignment(op) {
    return op.type === REMOVE_CONTROLLED_VOCABULARY_ASSIGNMENT;
}
export const MODIFY_CONTROLLED_VOCABULARY_ASSIGNMENT = "modify-controlled-vocabulary-assignment";
export function isModifyControlledVocabularyAssignment(op) {
    return op.type === MODIFY_CONTROLLED_VOCABULARY_ASSIGNMENT;
}
//# sourceMappingURL=operations.js.map